'use strict';
siteClaimsController.$inject = ['$scope', '$location', '$q', '$filter', '$timeout', 'dialogHelper', 'siteClaimsService', 'authService'];
angular.module('schoolLinqApp').controller('siteClaimsController', siteClaimsController);

function siteClaimsController($scope, $location, $q, $filter, $timeout, dialogHelper, siteClaimsService, authService) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$scope.loadingPromise = $q.all([LoadSiteClaims($scope.vm)]);

	function getViewModel() {
		var model = {
			siteClaims: {},
			claims: {},
			changedItems: [],
			errors: null,
			message: 'Loading ....',
		};

		function activeChanged(model, page, module) {
			if (
				page.Id !== 0 &&
				!_.find(model.changedItems, function (changed) {
					return changed.Id === page.Id;
				})
			) {
				model.changedItems.push(page);
			}
			page.Active = !page.Active;
			if (page.Id === 0) {
				// the 'Select All' item was changed, update all
				angular.forEach(module, function (item) {
					if (item.Active !== page.Active) {
						item.Active = page.Active;
						if (
							!_.find(model.changedItems, function (changed) {
								return changed.Id === item.Id;
							})
						) {
							model.changedItems.push(item);
						}
					}
				});
			} else if (page.Active === false) {
				// item was unchecked, update the 'Select All' item
				var allItem = _.find(module, function (item) {
					return item.Id === 0;
				});
				if (allItem) {
					allItem.Active = false;
				}
			} else {
				// item was checked, see if all items are checked
				var allChecked = true;
				angular.forEach(module, function (item) {
					if (item.Id !== 0 && item.Active === false) {
						allChecked = false;
					}
				});
				if (allChecked) {
					// all items are checked, update the 'Select All' item
					allItem = _.find(module, function (item) {
						return item.Id === 0;
					});
					if (allItem) {
						allItem.Active = allChecked;
					}
				}
			}
			$scope.siteClaimsForm.$setDirty();
		}

		function totalModuleItemsSelected(model, module) {
			return _.filter(module, function (page) {
				return page.Id !== 0 && page.Active === true;
			}).length;
		}

		function totalSectionItemsSelected(model, section) {
			var total = 0;
			angular.forEach(section, function (item) {
				total += model.totalModuleItemsSelected(item);
			});

			return total;
		}

		function activateAll(model, section, active) {
			angular.forEach(section, function (item) {
				if (item.Active !== active) {
					item.Active = active;
					if (item.Id !== 0) {
						if (
							!_.find(model.changedItems, function (changed) {
								return changed.Id === item.Id;
							})
						) {
							model.changedItems.push(item);
						}
					}
				}
			});
			if (model.changedItems.length > 0) {
				$scope.siteClaimsForm.$setDirty();
			}
		}

		function formIsDirty(model) {
			return $scope.siteClaimsForm.$dirty;
		}

		function saveChanges(model) {
			model.errors = null;
			var oldMessage = model.message;
			model.message = 'Saving ....';

			$scope.loadingPromise = siteClaimsService.updateActiveFlag(model.changedItems).then(_.partial(finishedSaving, model));

			function finishedSaving(model, response) {
				if (response.data.isValid) {
					$scope.siteClaimsForm.$setPristine();
					$scope.siteClaimsForm.$setUntouched();
					return $q.all([LoadSiteClaims($scope.vm)]);
				} else {
					model.errors = response.data.errors;
					return angular.noop;
				}
			}
			model.message = oldMessage;
		}

		function cancelChanges(model) {
			model.changedItems = [];
			$scope.siteClaimsForm.$setPristine();
			$scope.siteClaimsForm.$setUntouched();
			model.errors = null;
			$scope.loadingPromise = $q.all([LoadSiteClaims($scope.vm)]);
		}

		return angular.extend(model, {
			activeChanged: _.partial(activeChanged, model),
			totalModuleItemsSelected: _.partial(totalModuleItemsSelected, model),
			totalSectionItemsSelected: _.partial(totalSectionItemsSelected, model),
			activateAll: _.partial(activateAll, model),
			formIsDirty: _.partial(formIsDirty, model),
			saveChanges: _.partial(saveChanges, model),
			cancelChanges: _.partial(cancelChanges, model),
		});
	}

	function LoadSiteClaims(model) {
		return siteClaimsService.getSiteClaims().then(_.partial(finishedLoadingSiteClaims, model));

		function finishedLoadingSiteClaims(model, response) {
			if (response.data.isValid) {
				model.changedItems = [];
				model.siteClaims = response.data.siteClaims;
				// SYSTEM SETTINGS
				model.systemPermission = _.where(model.siteClaims, {
					Section: 'system',
				});
				var systemUniq = _.uniq(model.systemPermission, function (item, key, Module) {
					return item.Module;
				});
				model.claims['system'] = {};
				model.claims.system.totalItems = 0;
				angular.forEach(systemUniq, function (module) {
					model.claims.system[module.Module] = _.where(model.systemPermission, {
						Module: module.Module,
					});
					model.claims.system[module.Module] = _.sortBy(model.claims.system[module.Module], 'Ordinal');
					model.claims.system[module.Module].totalItems = model.claims.system[module.Module].length;
					model.claims.system.totalItems += model.claims.system[module.Module].totalItems;
					var addAllItem = model.claims.system[module.Module].length > 1;
					if (addAllItem) {
						// add the 'Select All' item defaulted to True
						var allItem = { Id: 0, Active: true };
						model.claims.system[module.Module].unshift(allItem);
						model.systemPermission.unshift(allItem);
					}
					// check if any items are unselected
					angular.forEach(model.claims.system[module.Module], function (page) {
						if (addAllItem && page.Active === false) {
							// set 'Select All' item to False
							model.claims.system[module.Module][0].Active = false;
						}

						page.activeChanged = model.activeChanged;
					});
				});
				// PAYROLL
				model.payrollPermission = _.where(model.siteClaims, {
					Section: 'payroll',
				});
				var payrollUniq = _.uniq(model.payrollPermission, function (item, key, Module) {
					return item.Module;
				});
				model.claims['payroll'] = {};
				model.claims.payroll.totalItems = 0;
				angular.forEach(payrollUniq, function (module) {
					model.claims.payroll[module.Module] = _.where(model.payrollPermission, { Module: module.Module });
					model.claims.payroll[module.Module] = _.sortBy(model.claims.payroll[module.Module], 'Ordinal');
					model.claims.payroll[module.Module].totalItems = model.claims.payroll[module.Module].length;
					model.claims.payroll.totalItems += model.claims.payroll[module.Module].totalItems;
					var addAllItem = model.claims.payroll[module.Module].length > 1;
					if (addAllItem) {
						// add the 'Select All' item defaulted to True
						var allItem = { Id: 0, Active: true };
						model.claims.payroll[module.Module].unshift(allItem);
						model.payrollPermission.unshift(allItem);
					}
					// check if any items are unselected
					angular.forEach(model.claims.payroll[module.Module], function (page) {
						if (addAllItem && page.Active === false) {
							// set 'Select All' item to False
							model.claims.payroll[module.Module][0].Active = false;
						}

						page.activeChanged = model.activeChanged;
					});
				});
				// FUND MANAGEMENT
				model.fundPermission = _.where(model.siteClaims, { Section: 'fund' });
				var fundUniq = _.uniq(model.fundPermission, function (item, key, Module) {
					return item.Module;
				});
				model.claims['fund'] = {};
				model.claims.fund.totalItems = 0;
				angular.forEach(fundUniq, function (module) {
					model.claims.fund[module.Module] = _.where(model.fundPermission, {
						Module: module.Module,
					});
					model.claims.fund[module.Module] = _.sortBy(model.claims.fund[module.Module], 'Ordinal');
					model.claims.fund[module.Module].totalItems = model.claims.fund[module.Module].length;
					model.claims.fund.totalItems += model.claims.fund[module.Module].totalItems;
					var addAllItem = model.claims.fund[module.Module].length > 1;
					if (addAllItem) {
						// add the 'Select All' item defaulted to True
						var allItem = { Id: 0, Active: true };
						model.claims.fund[module.Module].unshift(allItem);
						model.fundPermission.unshift(allItem);
					}
					// check if any items are unselected
					angular.forEach(model.claims.fund[module.Module], function (page) {
						if (addAllItem && page.Active === false) {
							// set 'Select All' item to False
							model.claims.fund[module.Module][0].Active = false;
						}

						page.activeChanged = model.activeChanged;
					});
				});
				// SCHOOL BOOKKEEPING
				model.saPermission = _.where(model.siteClaims, { Section: 'lsb' });
				var saUniq = _.uniq(model.saPermission, function (item, key, Module) {
					return item.Module;
				});
				model.claims['sa'] = {};
				model.claims.sa.totalItems = 0;
				angular.forEach(saUniq, function (module) {
					model.claims.sa[module.Module] = _.where(model.saPermission, {
						Module: module.Module,
					});
					model.claims.sa[module.Module] = _.sortBy(model.claims.sa[module.Module], 'Ordinal');
					model.claims.sa[module.Module].totalItems = model.claims.sa[module.Module].length;
					model.claims.sa.totalItems += model.claims.sa[module.Module].totalItems;
					var addAllItem = model.claims.sa[module.Module].length > 1;
					if (addAllItem) {
						// add the 'Select All' item defaulted to True
						var allItem = { Id: 0, Active: true };
						model.claims.sa[module.Module].unshift(allItem);
						model.saPermission.unshift(allItem);
					}
					// check if any items are unselected
					angular.forEach(model.claims.sa[module.Module], function (page) {
						if (addAllItem && page.Active === false) {
							// set 'Select All' item to False
							model.claims.sa[module.Module][0].Active = false;
						}

						page.activeChanged = model.activeChanged;
					});
				});
				//  BUDGET BUILDER
				model.budgetPermission = _.where(model.siteClaims, {
					Section: 'budget',
				});
				var budgetUniq = _.uniq(model.budgetPermission, function (item, key, Module) {
					return item.Module;
				});
				model.claims['budget'] = {};
				model.claims.budget.totalItems = 0;
				angular.forEach(budgetUniq, function (module) {
					model.claims.budget[module.Module] = _.where(model.budgetPermission, {
						Module: module.Module,
					});
					model.claims.budget[module.Module] = _.sortBy(model.claims.budget[module.Module], 'Ordinal');
					model.claims.budget[module.Module].totalItems = model.claims.budget[module.Module].length;
					model.claims.budget.totalItems += model.claims.budget[module.Module].totalItems;
					var addAllItem = model.claims.budget[module.Module].length > 1;
					if (addAllItem) {
						// add the 'Select All' item defaulted to True
						var allItem = { Id: 0, Active: true };
						model.claims.budget[module.Module].unshift(allItem);
						model.budgetPermission.unshift(allItem);
					}
					// check if any items are unselected
					angular.forEach(model.claims.budget[module.Module], function (page) {
						if (addAllItem && page.Active === false) {
							// set 'Select All' item to False
							model.claims.budget[module.Module][0].Active = false;
						}

						page.activeChanged = model.activeChanged;
					});
				});
				//  Fixed Assets
				model.faPermission = _.where(model.siteClaims, {
					Section: 'fa',
				});
				var faUniq = _.uniq(model.faPermission, function (item, key, Module) {
					return item.Module;
				});
				model.claims['fa'] = {};
				model.claims.fa.totalItems = 0;
				angular.forEach(faUniq, function (module) {
					model.claims.fa[module.Module] = _.where(model.faPermission, {
						Module: module.Module,
					});
					model.claims.fa[module.Module] = _.sortBy(model.claims.fa[module.Module], 'Ordinal');
					model.claims.fa[module.Module].totalItems = model.claims.fa[module.Module].length;
					model.claims.fa.totalItems += model.claims.fa[module.Module].totalItems;
					var addAllItem = model.claims.fa[module.Module].length > 1;
					if (addAllItem) {
						// add the 'Select All' item defaulted to True
						var allItem = { Id: 0, Active: true };
						model.claims.fa[module.Module].unshift(allItem);
						model.faPermission.unshift(allItem);
					}
					// check if any items are unselected
					angular.forEach(model.claims.fa[module.Module], function (page) {
						if (addAllItem && page.Active === false) {
							// set 'Select All' item to False
							model.claims.fa[module.Module][0].Active = false;
						}

						page.activeChanged = model.activeChanged;
					});
				});
				// EmployeeLINQ
				model.employeelinqPermission = _.where(model.siteClaims, {
					Section: 'employeelinq',
				});
				var employeelinqUniq = _.uniq(model.employeelinqPermission, function (item, key, Module) {
					return item.Module;
				});
				model.claims['employeelinq'] = {};
				model.claims.employeelinq.totalItems = 0;
				angular.forEach(employeelinqUniq, function (module) {
					model.claims.employeelinq[module.Module] = _.where(model.employeelinqPermission, {
						Module: module.Module,
					});
					model.claims.employeelinq[module.Module] = _.sortBy(model.claims.employeelinq[module.Module], 'Ordinal');
					model.claims.employeelinq[module.Module].totalItems = model.claims.employeelinq[module.Module].length;
					model.claims.employeelinq.totalItems += model.claims.employeelinq[module.Module].totalItems;
					var addAllItem = model.claims.employeelinq[module.Module].length > 1;
					if (addAllItem) {
						// add the 'Select All' item defaulted to True
						var allItem = { Id: 0, Active: true };
						model.claims.employeelinq[module.Module].unshift(allItem);
						model.employeelinqPermission.unshift(allItem);
					}
					// check if any items are unselected
					angular.forEach(model.claims.employeelinq[module.Module], function (page) {
						if (addAllItem && page.Active === false) {
							// set 'Select All' item to False
							model.claims.employeelinq[module.Module][0].Active = false;
						}

						page.activeChanged = model.activeChanged;
					});
				});
			} else {
				model.errors = response.data.errors;
			}
			return angular.noop;
		}
	}

	var onRouteChangeOff = $scope.$on('$locationChangeStart', _.partial(dialogHelper.routeChange, $scope.vm.formIsDirty, acceptFunction));

	function acceptFunction() {
		onRouteChangeOff(); //Stop listening for location changes
		return angular.noop;
	}
}
